import localForage from 'localforage';
import axios from 'axios';
import config from '@/config/app.config';
import MigrationService from '@/services/migration.service';
import { download } from '../utils/helpers';

function getHttpClient() {
  const http = axios.create({
    baseURL: config.api_url,
  });
  const token = localStorage.getItem('auth_token');
  if (token) {
    http.defaults.headers.common.Authorization = `Bearer ${token}`;
  }
  return http;
}

export default {
  namespaced: true,
  state: {
    isImportModalOpen: false,
  },
  mutations: {
    isImportModalOpen(state, isOpen) {
      state.isImportModalOpen = isOpen;
    },
  },
  actions: {
    async migrate() {
      return MigrationService.migrate();
    },
    async exportJson() {
      if (config.storageType === 'http') {
        const http = getHttpClient();
        const res = await http.get('/api');
        download(JSON.stringify(res.data), 'serverless-invoices.json', 'application/json');
        return;
      }

      let results = [];
      const keys = await localForage.keys();
      keys.forEach((key) => {
        results.push(localForage.getItem(key));
      });
      results = await Promise.all(results);

      const data = {};
      keys.forEach((key, index) => {
        data[key] = results[index];
      });

      download(JSON.stringify(data), 'serverless-invoices.json', 'application/json');
    },
    async importJson({ dispatch }, data) {
      if (!data || typeof data !== 'object' || Array.isArray(data)) {
        throw new Error('Import data must be a JSON object');
      }

      const arrayKeys = ['invoices', 'clients', 'taxes', 'bankAccounts'];
      for (const key of arrayKeys) {
        if (data[key] !== undefined && !Array.isArray(data[key])) {
          throw new Error(`"${key}" must be an array`);
        }
      }

      if (Array.isArray(data.invoices)) {
        data.invoices.forEach((inv, i) => {
          if (!inv.id) throw new Error(`Invoice at index ${i} is missing an "id" field`);
        });
      }

      if (Array.isArray(data.clients)) {
        data.clients.forEach((client, i) => {
          if (!client.id) throw new Error(`Client at index ${i} is missing an "id" field`);
        });
      }

      if (config.storageType === 'http') {
        const http = getHttpClient();
        await http.post('/api', data);
        await dispatch('teams/terminate', null, { root: true });
        return dispatch('teams/init', null, { root: true });
      }

      const results = [];
      Object.keys(data).forEach((key) => {
        results.push(localForage.setItem(key, data[key]));
      });
      await Promise.all(results);
      await dispatch('teams/terminate', null, { root: true });
      return dispatch('teams/init', null, { root: true });
    },
  },
  getters: {},
};
